export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/influencer_marketing.9748a36.svg";